"use client";

import { useEffect } from "react";
import posthog from "posthog-js";

export default function GlobalError({
  error,
}: {
  error: Error & {
    digest?: string;
    name?: string;
    stack?: string;
    message?: string;
  };
}) {
  useEffect(() => {
    // Log unexpected errors automatically to PostHog
    posthog.capture("$exception", {
      $exception_message: error.message,
      $exception_name: error.name,
      $exception_stack: error.stack,
      $exception_digest: error.digest,
    });
    console.error(error);
  }, [error]);

  return (
    <html>
      <body>
        <div className="flex h-screen w-full flex-col items-center justify-center p-4">
          <h2 className="mb-4 text-2xl font-bold">Something went wrong!</h2>
          <button
            className="rounded-md bg-primary px-4 py-2 text-primary-foreground hover:bg-primary/90"
            onClick={() => window.location.reload()}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
